"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonCommentsLayout = exports.PersonCommentsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var comment_1 = require("./comment");
var router_1 = require("@reach/router");
var use_entities_1 = require("../../hooks/use-entities");
var entity_divider_1 = require("./entity-divider");
var elllipsis_divider_1 = require("../elements/elllipsis-divider");
exports.PersonCommentsLayoutDefaultProps = {
  items: []
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 ", ";\n    ", ";\n  "], ["\n    margin: 0 ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.V_DOT_BG())
});
var ConversationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    text-decoration: none;\n    cursor: pointer;\n    padding: 0 ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    text-decoration: none;\n    cursor: pointer;\n    padding: 0 ", ";\n  "])), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme_1.theme.UNIT(1))
});
var CommentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-bottom: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(6))
});
var EntityStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var RepliesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-right: ", ";\n    padding-top: ", ";\n    padding-left: ", ";\n    padding-bottom: ", ";\n  "], ["\n    padding-right: ", ";\n    padding-top: ", ";\n    padding-left: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2), theme_1.theme.UNIT(5), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-right: ", ";\n    padding-left: ", ";\n  "], ["\n    padding-right: ", ";\n    padding-left: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(15))
});
var EllipsisDividerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: -24px;\n  "], ["\n    margin-top: -24px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Conversation: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ConversationStyles),
  EllipsisDivider: (0, styled_components_1.default)(elllipsis_divider_1.EllipsisDivider)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), EllipsisDividerStyles),
  Entity: (0, styled_components_1.default)(entity_divider_1.EntityDivider)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), EntityStyles),
  Comment: (0, styled_components_1.default)(comment_1.Comment)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), CommentStyles),
  Replies: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), RepliesStyles)
};
var PersonCommentsLayout = function (props) {
  var className = props.className,
    items = props.items,
    person = props.person;
  var entities = (0, use_entities_1.useEntities)();
  var lastEntity;
  return react_1.default.createElement(My.Container, {
    className: className
  }, items.map(function (comment) {
    var entity = comment.entity;
    var isReply = !!comment.parent;
    // if the comment is a reply to a comment started by this person, don't show it (as it will be shown under the main comment)
    var showComment = !(comment.parent && comment.parent.createdBy && comment.parent.createdBy.id === person.id);
    if (entity && showComment) {
      var showEntity = !lastEntity || entity.id !== lastEntity.id;
      lastEntity = entity;
      var defn_1 = entities[entity.__typename];
      if (defn_1) {
        return react_1.default.createElement(My.Conversation, {
          onClick: function () {
            return (0, router_1.navigate)(defn_1.to(entity.slug, 'conversation'));
          }
        }, showEntity ? react_1.default.createElement(My.Entity, {
          entity: entity
        }) : react_1.default.createElement(My.EllipsisDivider, null), react_1.default.createElement(My.Comment, {
          key: comment.id,
          showEditControls: false,
          entity: comment
        }), comment.replies && react_1.default.createElement(My.Replies, null, comment.replies.map(function (reply) {
          return react_1.default.createElement(My.Comment, {
            showEditControls: false,
            isReply: true,
            entity: reply
          });
        })));
      }
    }
  }));
};
exports.PersonCommentsLayout = PersonCommentsLayout;
exports.PersonCommentsLayout.defaultProps = exports.PersonCommentsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;